import React from "react";
import { AlertCircle, RefreshCw } from "lucide-react";

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[pulse-connectors]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="setup-container" role="alert">
          <div className="notice notice--error">
            <AlertCircle aria-hidden="true" size={20} />
            <div>
              <h1 className="notice__title">Setup is unavailable right now.</h1>
              <p className="notice__body">
                Your setup is saved. Refresh the page or contact Pulse support if this keeps happening.
              </p>
            </div>
          </div>
          <button className="btn btn--secondary" type="button" onClick={() => this.setState({ hasError: false })}>
            <RefreshCw size={16} aria-hidden="true" />
            Retry
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}
